import { createStaticTranslateKey } from './create-static-translate-key';

/**
 * Label of the leading "Home" crumb in generated breadcrumbs (UI + JSON-LD).
 * Comes from Crowdin instead of the `home` story so pages don't have to load
 * the whole homepage to read its name.
 */
export const BREADCRUMB_HOME_KEY = createStaticTranslateKey('Home', 'breadcrumb.home');
